import { useSelector } from 'react-redux'
import { State } from 'src/state'
import { Button } from 'src/global'
import Setting from '../Setting'
import { RoundIconWrapper } from './styles'

export default function NameSetting() {
  const { user } = useSelector((state: State) => state.users)

  if (!user) {
    return null
  }

  return (
    <RoundIconWrapper>
      <Setting
        title="Numele Restaurantului / Meniului"
        icon={user.logoUrl && <img className="logo" src={user.logoUrl} alt="Logo" />}
        iconPath={user.logoUrl ? undefined : '/icons/pencil.png'}
        rightButton={
          <Button
            variant="as-text"
            text="Modifică..."
            onClick={() => window.openChangeNameModal()}
            style={{ marginTop: 0, padding: 0, paddingRight: 8 }}
          />
        }
        infoText={
          <>
            Numele curent: <b>{user.name}</b>.
          </>
        }
      />
    </RoundIconWrapper>
  )
}
